module.exports = __webpack_public_path__ + "img/017-christmas-island.c0bed957.svg";